import { useState } from 'react';
import translations from '../../../../translations';
import { isNullOrEmpty } from '../../../../utils/guard';
import FormGroup from '../../../generic/FormGroup';
import NameInput from '../common/NameInput';
import OutcomeList from '../common/outcomes/OutcomeList';
import { useMapElement } from '../contextProviders/MapElementProvider';
import ModalBody from '../../../generic/modal/ModalBody';
import ModalFooter from '../../../generic/modal/ModalFooter';
import Footer from '../common/Footer';
import type { MapElementRequestAPI } from '../../../../sources/graph';

const DecisionConfiguration = () => {
    const [hasSubmitted, setHasSubmitted] = useState(false);

    const { mapElement, onUpdateName, onUpdateComments, onSaveMapElement, onClose } =
        useMapElement();

    if (!mapElement) {
        onClose();
        return;
    }

    const { developerName, developerSummary } = mapElement;

    const isDecisionElementNameValid = !isNullOrEmpty(developerName);

    const onSave = () => {
        setHasSubmitted(true);
        if (isDecisionElementNameValid) {
            onSaveMapElement(mapElement as MapElementRequestAPI);
        }
    };

    const renderBody = () => (
        <>
            <NameInput
                isValid={isDecisionElementNameValid}
                showValidation={hasSubmitted}
                id="decision-element-name"
                name={mapElement.developerName ?? ''}
                onUpdateName={onUpdateName}
            />
            <OutcomeList />
            <FormGroup htmlFor="decision-element-comments" label="Comments about this Decision">
                <textarea
                    id="decision-element-comments"
                    className="form-control form-textarea"
                    value={developerSummary ?? ''}
                    onChange={(e) => onUpdateComments(e.target.value)}
                />
            </FormGroup>
        </>
    );

    const renderFooter = () => {
        return (
            <Footer
                save={onSave}
                saveButtonText={translations.GRAPH_config_panel_save}
                cancel={onClose}
            />
        );
    };

    return (
        <>
            <ModalBody>{renderBody()}</ModalBody>
            <ModalFooter>{renderFooter()}</ModalFooter>
        </>
    );
};

export default DecisionConfiguration;
